// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { muiGlobalTheme } from '@themes';
import { colors } from '../../css';

function limit(val, max) {
  let newVal = val;
  if (newVal.length === 1 && newVal[0] > max[0]) {
    newVal = `0${newVal}`;
  }

  if (newVal.length === 2) {
    if (Number(newVal) === 0) {
      newVal = '01';

      // this can happen when user paste number
    } else if (newVal > max) {
      newVal = max;
    }
  }

  return newVal;
}

function dateFormat(val) {
  const year = val.substring(0, 4);
  const month = limit(val.substring(4, 6), '12');
  const day = limit(val.substring(6, 8), '31');

  return year + (month.length ? `-${month}` : '') + (day.length ? `-${day}` : '');
}

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      format={dateFormat}
      placeholder="YYYY-MM-DD"
      mask={['Y', 'Y', 'Y', 'Y', 'M', 'M', 'D', 'D']}
    />
  );
}
NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

function DateInput(props) {
  const { errorText, helperText, type, variant, ...defaultProps } = props;
  const { error, InputProps } = defaultProps;

  muiGlobalTheme.palette.text.primary = '#000';
  muiGlobalTheme.palette.text.secondary = colors.colorGrey03;
  muiGlobalTheme.components.MuiIconButton = {
    styleOverrides: { root: { marginBottom: '10px' } }
  };

  const inputTheme = createTheme(muiGlobalTheme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={inputTheme}>
        <TextField
          variant={variant}
          {...defaultProps}
          fullWidth
          helperText={error ? errorText : helperText}
          InputProps={{
            inputComponent: NumberFormatCustom,
            inputProps: {
              ...InputProps,
              ...defaultProps
            }
          }}
        />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

DateInput.propTypes = {
  /**
   * Message that is displayed when the input has an error
   */
  errorText: PropTypes.string,
  /**
   * Optional helper text that sits below the input
   */
  helperText: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.string
};
DateInput.defaultProps = {
  errorText: 'Error',
  helperText: undefined,
  type: undefined,
  variant: 'standard'
};

export default DateInput;
